import React from 'react';
import { getFullNameByEmail } from '../../App';

const AdminTickets = ({ tickets, users, onUpdateStatus, statusFilter, setStatusFilter }) => {
  const filteredTickets = statusFilter === 'all'
    ? tickets
    : tickets.filter(ticket => ticket.status === statusFilter);

  const getStatusLabel = (status) => {
    const labels = {
      open: '🔴 Açık',
      in_progress: '🟡 İşlemde',
      closed: '🟢 Kapalı',
      procurement: '🟣 Tedarik Sürecinde'
    };
    return labels[status] || status;
  };

  const getTypeLabel = (type) => {
    const labels = {
      ariza: '🔧 Arıza',
      sayim: '📊 Sayım',
      degisim: '🔄 Değişim',
      genel: '✉️ Genel'
    };
    return labels[type] || type;
  };

  return (
    <div className="admin-tickets">
      <h3>Tüm Talepler ({filteredTickets.length})</h3>

      {/* Filtreleme Butonları */}
      <div className="status-filter-buttons" style={{ marginBottom: '15px' }}>
        <button onClick={() => setStatusFilter('all')} className={statusFilter === 'all' ? 'active' : ''}>Tümü</button>
        <button onClick={() => setStatusFilter('open')} className={statusFilter === 'open' ? 'active' : ''}>Açık</button>
        <button onClick={() => setStatusFilter('in_progress')} className={statusFilter === 'in_progress' ? 'active' : ''}>İşlemde</button>
        <button onClick={() => setStatusFilter('closed')} className={statusFilter === 'closed' ? 'active' : ''}>Kapalı</button>
        <button onClick={() => setStatusFilter('procurement')} className={statusFilter === 'procurement' ? 'active' : ''}>Tedarik</button>
      </div>
      
      {filteredTickets.length === 0 ? (
        <div className="no-data">Henüz bu filtrede talep bulunmuyor.</div>
      ) : (
        <div className="tickets-table">
          {filteredTickets.map(ticket => (
            <div key={ticket.id} className="admin-ticket-card">
              <div className="ticket-info">
                <h4>{ticket.title}</h4>
                <p><strong>Kullanıcı:</strong> {getFullNameByEmail(ticket.user_email, users)}</p>
                <p><strong>Tür:</strong> {getTypeLabel(ticket.type)}</p>
                {ticket.product_name && (
                  <p><strong>İlgili Ürün:</strong> {ticket.product_name} ({ticket.product_code})</p>
                )}
                <p><strong>Açıklama:</strong> {ticket.description}</p>
                <p><strong>Tarih:</strong> {new Date(ticket.created_at).toLocaleString('tr-TR')}</p>
              </div>
              
              <div className="ticket-actions">
                <div className="current-status">
                  <strong>Durum:</strong> {getStatusLabel(ticket.status)}
                </div>
                
                <div className="status-buttons">
                  <button 
                    onClick={() => onUpdateStatus(ticket.id, 'open')}
                    className={`btn-status ${ticket.status === 'open' ? 'active' : ''}`}
                  >
                    Aç
                  </button>
                  <button 
                    onClick={() => onUpdateStatus(ticket.id, 'in_progress')}
                    className={`btn-status ${ticket.status === 'in_progress' ? 'active' : ''}`}
                  >
                    İşlemde
                  </button>
                  <button 
                    onClick={() => onUpdateStatus(ticket.id, 'closed')}
                    className={`btn-status ${ticket.status === 'closed' ? 'active' : ''}`}
                  >
                    Kapat
                  </button>
                  <button 
                    onClick={() => onUpdateStatus(ticket.id, 'procurement')}
                    className={`btn-status ${ticket.status === 'procurement' ? 'active' : ''}`}
                  >
                    Tedarik Sürecinde
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminTickets;
